import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchTests } from '../../utils/testApi';

function TestList() {
  const navigate = useNavigate();
  const [themes, setThemes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const loadThemes = async () => {
      try {
        setLoading(true);
        setError('');
        const result = await fetchTests();
        setThemes(result.data?.themes || []);
      } catch (err) {
        setError(err.message || 'テスト一覧の取得に失敗しました');
      } finally {
        setLoading(false);
      }
    };

    loadThemes();
  }, []);

  return (
    <div className="max-w-6xl mx-auto p-4 md:p-6">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl md:text-3xl font-bold text-gray-900">Webテスト</h1>
        <button
          type="button"
          onClick={() => navigate('/tests/history')}
          className="px-4 py-2 bg-gray-100 text-gray-800 rounded-md hover:bg-gray-200"
        >
          回答履歴
        </button>
      </div>

      {loading ? (
        <div className="flex justify-center items-center min-h-[240px]">
          <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600" />
        </div>
      ) : error ? (
        <div className="bg-red-50 border border-red-200 rounded-md p-4">
          <p className="text-sm text-red-600">{error}</p>
        </div>
      ) : themes.length === 0 ? (
        <div className="bg-white rounded-lg shadow p-6">
          <p className="text-sm text-gray-500">利用可能なテストテーマがありません</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {themes.map((theme) => (
            <div key={theme.id} className="bg-white rounded-lg shadow p-5 border border-gray-100">
              <h2 className="text-lg font-semibold text-gray-900">{theme.name}</h2>
              <p className="text-sm text-gray-600 mt-2 whitespace-pre-wrap min-h-[48px]">
                {theme.description || '説明なし'}
              </p>
              <div className="mt-4">
                <button
                  type="button"
                  onClick={() => navigate(`/tests/${theme.id}`)}
                  className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                >
                  開始
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default TestList;
